import { Injectable } from '@angular/core';
let languageProducts: string[] = [
  "English",
  "Marathi",
];
export class LanguageList{
  Program: string;
  StartDate: string;
  EndDate: string;
  Apply:string;
  LateDate:string;
  ApplicationNO:string;
  Paymentstatus:string;
  ApprovedLevel:string;
  Download:string;
  PRNNO:string;
  ApplicationDate:string;
  ProgramDetails:string;
  Pattern:string;
  Specialization:string;
  SemPart:string;
  SemPartNO:string;
  College:string;
  Fees:string;
  DocumentName:string;
  FeeDetails:string;
  View:string;
  Upload:string;
  Submit:string;
  Cancel:string;
  PrintForm:string;
  PayOnline:string;
  PrintReceipt:string;
  Close:string;
  BonafideCertificate:string;
  PrefixSalutation:string;
  LastName:string;
  FirstName:string;
  FatherHusbandName:string;
  FullName:string;
  Gender:string;
  DateofBirth:string;
  Age:string;
  MobileNo:string;
  EmailID:string;
  Next:string;
  
  AccountNo:string;
  Accepted:string;
  NotAccepted:string;
  AddNew:string;
  Address:string;
  Address1:string;
  Address2:string;
  Address3:string;
  AddressDetails:string;
  AdmissionFor:string;
  AdmissionMethod:string;
  AdmissionSchedule:string;
  AdmissionStartDate:string;
  AdmissionType:string;
  ApplicationCancel:string;
  ApplicationNo:string;
  ApplicationStatus:string;
  ApplicationForm:string;
  Back:string;
  BackToLogin:string;
  BankBranchName:string;
  BankDetails:string;
  BankName:string;
  BloodGroup:string;
  Board:string;
  ByDate:string;
  Caste:string;
  Category:string;
  CategoryFees:string;
  Center:string;
  CenterChangeRemark:string;
  CGPA:string;
  City:string;
  CityProvince:string;
  CityTownVillage:string;
  Code:string;
  CollegeChangeRemark:string;
  CurrentCollege:string;
  CollegeFees:string;
  CollegeToMigrate:string;
  CollegeInstitute:string;
  Compulsory:string;
  ConfirmPassword:string;
  Confirmation:string;
  Continue:string;
  CorrespondenceAddress:string;
  Country:string;
  Course:string;
  CourseCode:string;
  CourseDetails:string;
  CourseNameObtainedMarks:string;
  MarksheetFile1:string;
  MarksheetFile2:string;
  PaymentReceiptFile:string;
  PaymentReceiptFileExternal:string;
  Delete:string;
  Description:string;
  Details:string;
  District:string;
  DrivingLicenceNo:string;
  EducationType:string;
  EducationalStream:string;
  EnrollmentFormDate:string;
  EnterEmailOTP:string;
  EnterOTP:string;
  EntranceExamFlag:string;
  Exam:string;
  ExamFormDate:string;
  ExamFormFees:string;
  ExamInstance:string;
  FatherHusbandGuardianLastName:string;
  FatherHusbandGuardianMiddleName:string;
  FatherHusbandGuardianName:string;
  FeesAmount:string;
  File1:string;
  Find:string;
  ForeignAddress:string;
  ForgotPassword:string;
  FormNo:string;
  GenerateOTP:string;
  Grade:string;
  GradeClass:string;
  GuardianOccupation:string;
  GuardianParentMobileNo:string;
  GuardianParentPhoneNo:string;
  Hobby:string;
  IfMinorityPleaseSelect:string;
  IFSCCode:string;
  InformMessage:string;
  IsPermanentAddresssameasCorrespondenceAddress:string;
  LastDateofFormSubmission:string;
  LateFees:string;
  ListofColleges:string;
  Login:string;
  MaritalStatus:string;
  MiddleName:string;
  MoblieOTP:string;
  MonthofPassing:string;
  MonthofPassingAppear:string;
  MotherLastName:string;
  MotherMiddleName:string;
  MotherTongue:string;
  MothersName:string;
  NameofSchoolCollege:string;
  Nationality:string;
  NewMarks:string;
  NewPassword:string;
  NewStudentName:string;
  No:string;
  ObtainedMarks:string;
  ObtMarks:string;
  OK:string;
  OldPassword:string;
  OpenCategoryFees:string;
  OtherCaste:string;
  OtherStatus:string;
  Outof:string;
  OutofMarks:string;
  PANCardNo:string;
  Password:string;
  PassingMonth:String;
  Payment:string;
  PaymentMode:string;
  PaymentStatus:string;
  OfferStatus:string;
  Percentage:string;
  PermanentAddress:string;
  PhotoCopyApplicationStatus:string;
  PhysicalDisability:string;
  PinCode:string;
  PreviousExamDegree:string;
  PreviousCollege:string;
  PreviousProgram:string;
  PrincipalSubjectFirst:string;
  PrincipalSubjectSecond:string;
  Print:string;
  ProfileStatus:string;
  RefreshCaptcha:string;
  RegisterHere:string;
  RegisterWithPRNHere:string;
  EnrolmentManualForm:string;
  OnlinePaymentManual:string;
  StandardShcedule:string;
  InstructionforEnrolment:string;
  RegisteredForVoter:string;
  RegisteredForVoterList:string;
  RegistrationType:string;
  RegularFees:string;
  Religion:string;
  Remove:string;
  RemoveFile :string;
  Edit:string;
  RequestDetails:string;
  RequestedCenter:string;
  RequestedCollege:string;
  RequestedSpecialization:string;
  ResendOTP:string;
  ResultDate:string;
  RevaluationApplicationStatus:string;
  ReVerificationApplicationStatus:string;
  Save:string;
  SeatNo:string;
  SeatNoRollNoLastExam:string;
  Select:string;
  SelectCenterToChange:string;
  SelectCollegeToChange:string;
  SelectCollegeToTransfer:string;
  SelectSpecializationToChange:string;
  SelectedColleges:string;
  SelectedSubjects:string;
  SocialReservation:string;
  SpecializationIfApplicable:string;
  SpecializationChangeRemark:string;
  SpecializationTotalTHPR:string;
  SpecializationSubject:string;
  Sports:string;
  Stage1:string;
  Stage2:string;
  Stage3:string;
  State:string;
  Status:string;
  StudentDetails:String;
  StudentName:string;
  PRNCINNo:string;
  StudentPhoto:string;
  StudentRegionalName:string;
  HSCMarkSheetName:string;
  StudentSeatNO:String;
  StudentSign:string;
  StudentType:string;
  SyllabusGroup:string;
  Tahsil:string;
  TotalAmount:string;
  TotalFees:string;
  TotalMarksObtained:string;
  Type:string;
  TypetheAboveText:string;
  University:string;
  UniversityFees:string;
  UniversityToMigrate
  UniversityBoard:string;
  UploadPhoto:string;
  UrbanRuralType:string;
  UserName:string;
  VerificationApplicationStatus:string;
  VerifyOTP:string;
  VisaNumber:string;
  VisaValidity:string;
  YearofPassing:string;
  YearofPassingAppear:string;
  YearTotalTHPR:string;
  Yes:string;
  YourFees:string;
  PersonalInfoI:string;
  PersonalInfoII:string;
  PhotoAndSignature:string;
  EducationalDetails:string;
  CommonDocuments:string;
  AreaofLocation:string;
  VoterID:string;
  AddUpdatePreviousExamDetails:string;
  PreviousExamDetails:string;
  CompanyDetails:string;
  Name:string;
  ProfilePreview:string;
  Youcanselectonly:string;
  CoursePerSemester:string;
  Prefix:string;
  Examination:string;
  ThirdSem:string;
  FourthSem:string;
  GraceNoteDetail:string;
  GraceNote:string;
  ToPass:string;
  Height:string;
  Weight:string;
  Chest:string; 
  MotherTongueTyping:string;
  MotherTongueTypingSpeed:string; 
  EnglishTyping:string;
  EnglishTypingSpeed:string;
  StenoTyping:string;  
  StenoTypingSpeed:string;  
  MSCIT:string;
  MSCITYear:string;
  MSCITGrade:string;
  MedicalCertificate : string;
  OthCourseName : string;
  OthCourseAuthority : string;
  OthCourseYear : string;
  OthCourseGrade : string;
  OthCourseCert: string;
  ApptitudeTest:string; 
  GroupDiscussion:string; 
  TechnicalInterview:string; 
  HRInterview:string; 
  FinalSelection:string;

  CategoryRequired:string;
  SubjectReuired:string;
  ReqiuredGraceSameForSubjectAndCategory:string;
  
  SPINSTR1:string;
  SPINSTR2:string;
  SPINSTR3:string;
  SPINSTR4:string;
  SPINSTR5:string;
  SPINSTR6:string;
  SPINSTR7:string;
  SPINSTR8:string;
  SPINSTR9:string;
  SPINSTR10:string;
  SPINSTR11:string;
  SPINSTR12:string;
  SPINSTR13:string;
  SPINSTR14:string;
  SPINSTR15:string;
  SPINSTR16:string;
  SPINSTR17:string;
  SPINSTR18:string;
  SPINSTR19:string;
  SPINSTR20:string;
  SPINSTR21:string;
  SPINSTR22:string;
  SPINSTR23:string;
  SPINSTR24:string;
  SPINSTR25:string;
  SPINSTR26:string;
  SPINSTR27:string;
  SPINSTR28:string;
  SPINSTR29:string;
  SPINSTR30:string;
  SPINSTR31:string;
  SPINSTR32:string;
  SPINSTR33:string;
  SPINSTR34:string;
  SPINSTR35:string;
  SPINSTR36:string;
  SPINSTR37:string;
  SPINSTR38:string;
  SPINSTR39:string;
  SPINSTR40:string;
  SPINSTR41:string;
  SPINSTR42:string;
  SPINSTR43:string;
  SPINSTR44:string;
  SPINSTR45:string;
  SPINSTR46:string;
  SPINSTR47:string;
  SPINSTR48:string;
  SPINSTR49:string;
  SPINSTR50:string;
  SPINSTR51:string;
  SPINSTR52:string;
  SPINSTR53:string;
  SPINSTR54:string;
  SPINSTR55:string;
  SPINSTR56:string;
  SPINSTR57:string;
  SPINSTR58:string;
  SPINSTR59:string;
  SPINSTR60:string;
  SPINSTR61:string;
  SPINSTR62:string;
  SPINSTR63:string;
  SPINSTR64:string;
  SPINSTR65:string;
  SPINSTR66:string;
  SPINSTR67:string;
  SPINSTR68:string;
  SPINSTR69:string;
  SPINSTR70:string;
  SPINSTR71:string;
  SPINSTR72:string;
  SPINSTR73:string;
  SPINSTR74:string;
  SPINSTR75:string;
  SPINSTR76:string;
  SPINSTR77:string;
  SPINSTR78:string;
  SPINSTR79:string;
  SPINSTR80:string;
  SPINSTR81:string;
  SPINSTR82:string;
  SPINSTR83:string;
  SPINSTR84:string;
  SPINSTR85:string;
  SPINSTR86:string;
  SPINSTR87:string;
  SPINSTR88:string;
  SPINSTR89:string;
  SPINSTR90:string;
  SPINSTR91:string;
  SPINSTR92:string;
  SPINSTR93:string;
  SPINSTR94:string;
  SPINSTR95:string;
  SPINSTR96:string;
  SPINSTR97:string;
  SPINSTR98:string;
  SPINSTR99:string;
  SPINSTR100:string;
  ApplicationTitle:string;
  IntegratedUniversityManagementSystem:string;
  Typetheabovetext:string;
  Donthaveanaccount:string;
  SelectLanguage:string;
  AdmissionStatus:string;
  EligibilityStatus:string;
  EligibilityDateRemark:string;
  ApprovalDateRemark:string;
  ApprovedStatus:string;
  GeneralMerit: string;
  PhysicalHandicapMerit: string;
  SocialReservationMerit: string;
  CasteMerit:string;
  FemaleMerit: string;
  SubmissionDate:string;
  HallTicketGeneration:string;
  HallTicketNo:string;
  EnteranceExamAttendance:string;
  EntranceResult:string;
  AllotmentStatus: string;
  Logout: string;
  TollFreeNo:string;
  Preference:string;
  PrintHallTicket:string;
  UniversityAdmissionsExaminationManagement:string
  SyllabusGroupINS:string;
  ExamGroup:string;
  ExamResult:string;
  ViewResult:string;
  BuildingName:string;
  RoomNo:string;
  BedNo:string;
  MessApplicable:string;
  RoomTypeName:string;
  HostelDetails:string;
  PrevPercentage:string;
  StudentLevel:string;
  Facilities:string;
  HostelType:string;
  PlacementCompanyRequirementDetail:string;
  CompanyName:string;
  DesignationName:string;JobLocation:string;
  NoOfPosts:string;
  CompanyAddress:string; 
  WebURL:string;
  TelephoneNo:string; 
  RequiredSkillSet:string;
  SalaryOffered:string;
  NoOfYearsBond:string;
  FeesHead:string;
  OnLinePaymentTransactionID:string;
  PaymentDate:string;
  NoOfInstallment:string;
  PaymentDetails:string;
  PendingFees:string;
  InstallmentFees:string;
  PayableAmount:string;
  ScholarshipName:string;
  AppliedForAnyStateOrNationalScholarship:string;
  CurrentProgramDetails:string;
  LastYearExamDetails:string;
  FromDate:string;
  NotificationDate:string;
  ToDate:string;
  ApplyFromDate:string;
  ApplyTillDate:string;
  ScholarshipDetail:string;
  ScholarshipRegistrationDetail:string;
  ScholarshipAppliedDetail:string;
  ScholarshipCategory:string;
  ApplyForScholarship:string;
  UrbanRuralTypeName:string;
  FatherIsAlive:string;
  MotherIsAlive:string;
  ApplicantIsEldestInTheFamily:string;
  FamilyIsDependentOnApplicant:string;
  ApplicantIsStudyingInNightCollege:string;
  SportName: string;
  SportDate: string;
  PlaceName: string;
  PerformanceType: string;
  Level: string;
  Rank: string;
  SPINSTR101:string;
  Marks:string;
  TotalMarks:string;
  GradePoints:string;
  ObtGradePoints:string;
  SGPA:string;
  
  FeedbackCategory:string;
  QuestionDescription:string;
  ProspectusFees:string;
  ProgramType:string;
  Medium:string;
  ProspectInstruction:string;
  ViewInstruction:string;
  GoToProfile:string;
  GoToLogIn:string;
  IAgreeText:string;
  Applycourseforview:string; 
  ProspectScheduleStartDate:string;
  ProspectScheduleEndDate:string;
  Student:string;
  CertificateTitle:string;
  CertificateAuthority:string;
  Subject:string;
  PurposeName:string;
  Narration:string;
  ReceiptNo:string;
  SchoolUdise:string;
  SaralID:string;
  AadharNoID:string;
  ABCID:string;
  SupportContacts:string;
  AcedemicYear:string;
  ISExternalStudent:string; 
  BirthPlace:string; 
  BirthThasil:string; 
  BirthDistrict:string; 
  BirthState:string; 
  BirthCountry:string; 
  LoginAS:string;
  InstructionForSelfRegistration:string;


  GrievanceSubmission:string;
  GrievanceType:string;
  Date:string;
  SelectFile:string;
  ActionTaken:string;
  Feedback:string;
  Division:string;
  RecessTime:string;
  WeeklyOff:string;
  SlotTime:string;
  Monday:string;
Tuesday:string;
Wednesday:string;
Thursday:string;
Friday:string;
Saturday:string;
Sunday:string;
Show:string;
Day:string;
Teacher:string;
HolidayDescription:string;
}
let EnglishList: LanguageList[]= [ {
  Program:  "Program",
  StartDate:"Start Date",
  EndDate:"End Date",
  Apply:"Apply",
  LateDate:"Late Date",
  ApplicationNO:"Application NO",
  Paymentstatus:"Payment status",
  ApprovedLevel:"Approved Level",
  Download:"Download",
  PRNNO:"REG NO.",
  ApplicationDate:"Application Date",
  ProgramDetails:"Program Details",
  Pattern:"Pattern",
  Specialization:"Specialization",
  SemPart:"Semester/Part",
  SemPartNO:"Semester/Part NO",
  College:"College",
  Fees:"Fees",
  DocumentName:"Document Name",
  FeeDetails:"Fee Details",
  View:"View",
  Upload:"Upload",
  Submit:"Submit",
  Cancel:"Cancel",
  PrintForm:"Print Form",
  PayOnline:"Pay Online",
  PrintReceipt:"Print Receipt",
  Close:"Close",
  BonafideCertificate:"Bonafide Certificate",
  PrefixSalutation:"Prefix/Salutation",
  LastName:"Last Name",
  FirstName:"First Name",
  FatherHusbandName:"Father/Husband Name",
  FullName:"Full Name",
  Gender:"Gender",
  DateofBirth:"Date of Birth",
  Age:"Age",
  MobileNo:"Mobile No.",
  EmailID:"Email ID",
  Next:"Next",
  AccountNo:"Account No.",
  Accepted:"Accept",
  NotAccepted:"Not Accept",
  AddNew:"Add New",
  Address:"Address",
  Address1:"Address 1",
  Address2:"Address 2",
  Address3:"Address 3",
  AddressDetails:"Address Details",
  AdmissionFor:"Admission For",
  AdmissionMethod:"Admission Method",
  AdmissionSchedule:"Admission Schedule",
  AdmissionStartDate:"Admission Start Date",
  AdmissionType:"Admission Type",
  ApplicationCancel:"Application Cancel",
  ApplicationNo:"Application No.",
  ApplicationStatus:"Application Status",
  ApplicationForm:"Application Form",
  Back:"Back",
  BackToLogin:"Back To Login",
  BankBranchName:"Bank Branch Name",
  BankDetails:"Bank Details",
  BankName:"Bank Name",
  BloodGroup:"Blood Group",
  Board:"Board",
  ByDate:"By Date",
  Caste:"Caste",
  Category:"Category",
  CategoryFees:"Category Fees",
  Center:"Center",
  CenterChangeRemark:"Center Change Remark",
  CGPA:"CGPA",
  SGPA:"SGPA",
  City:"City",
  CityProvince:"City/Province",
  CityTownVillage:"City/Town/Village",
  Code:"Code",
  CollegeChangeRemark:"College Change Remark",
  CurrentCollege :"Current College ",
  CollegeFees:"College Fees",
  CollegeToMigrate:"College To Migrate",
  CollegeInstitute:"College/Institute",
  Compulsory:"Compulsory",
  ConfirmPassword:"Confirm Password",
  Confirmation:"Confirmation",
  Continue:"Continue",
  CorrespondenceAddress:"Correspondence Address",
  Country:"Country",
  Course:"Course",
  CourseCode:"Course Code",
  CourseDetails:"Subject Details",
  CourseNameObtainedMarks:"Course Name (Obtained Marks)",  
  MarksheetFile1:"Last year/Semister Mark Sheet 1",
  MarksheetFile2:"Last year/Semister Mark Sheet 2",
  PaymentReceiptFile:"Last Year Payment Receipt",
  PaymentReceiptFileExternal:"TC/Migration Certificate",
  Delete:"Delete",
  Description:"Description",
  Details:"Details",
  District:"District",
  DrivingLicenceNo:"Driving Licence No.",
  EducationType:"Education Type",
  EducationalStream:"Educational Stream",
  EnrollmentFormDate:"Enrollment Form Date",
  EnterEmailOTP:"Enter Email OTP",
  EnterOTP:"Enter OTP",
  EntranceExamFlag:"Entrance Exam Flag",
  Exam:"Exam",
  ExamFormDate:"Exam Form Date",
  ExamFormFees:"Exam Form Fees",
  ExamInstance:"Exam Instance",
  FatherHusbandGuardianLastName:"Father/Husband/Guardian Last Name",
  FatherHusbandGuardianMiddleName:"Father/Husband/Guardian Middle Name",
  FatherHusbandGuardianName:"Father/Husband/Guardian Name",
  FeesAmount:"Fees Amount",
  File1:"File 1",
  Find:"Find",
  ForeignAddress:"Foreign Address	",
  ForgotPassword:"Forgot Password?",
  FormNo:"Form No.",
  GenerateOTP:"Generate OTP",
  Grade:"Grade",
  GradeClass:"Grade/Class	",
  GuardianOccupation:"Guardian Occupation",
  GuardianParentMobileNo:"Guardian/Parent Mobile No.",
  GuardianParentPhoneNo:"Guardian/Parent Phone No.",
  Hobby:"Hobby",
  IfMinorityPleaseSelect:"If Minority? Please Select",
  IFSCCode:"IFSC Code",
  InformMessage:"Inform Message",
  IsPermanentAddresssameasCorrespondenceAddress:"Is Permanent Address same as Correspondence Address ?",
  LastDateofFormSubmission:"Last Date of Form Submission",
  LateFees:"Late Fees",
  ListofColleges:"List of Colleges",
  Login:"Login",
  MaritalStatus:"Marital Status	",
  MiddleName:"Middle Name",
  MoblieOTP:"Moblie OTP",
  MonthofPassing:"Month of Passing",
  MonthofPassingAppear:"Month of Passing/Appear",
  MotherLastName:"Mother Last Name",
  MotherMiddleName:"Mother Middle Name",
  MotherTongue:"Mother Tongue",
  MothersName:"Mothers Name",
  NameofSchoolCollege:"Name of School/College",
  Nationality:"Nationality",
  NewMarks:"New Marks",
  NewPassword:"New Password",
  NewStudentName:"New Student Name",
  No:"No",
  ObtainedMarks:"Obtained Marks",
  ObtMarks:"Obt. Marks",
  OK:"OK",
  OldPassword:"Old Password",
  OpenCategoryFees:"Open Category Fees",
  OtherCaste:"Other Caste",
  OtherStatus:"Other Status",
  Outof:"Out of",
  OutofMarks:"Out of Marks",
  PANCardNo:"PAN Card No.",
  Password:"Password",
  PassingMonth:"Passing Month",
  Payment:"Payment",
  PaymentMode:"Payment Mode",
  PaymentStatus:"Payment Status",
  OfferStatus:"Offer Status",
  Percentage:"Percentage",
  PermanentAddress:"Permanent Address",
  PhotoCopyApplicationStatus:"Photo Copy Application Status",
  PhysicalDisability:"Physical Disability",
  PinCode:"Pin Code",
  PreviousExamDegree:"Previous Exam Degree",
  PreviousCollege:"Previous College",
  PreviousProgram:"Previous Program",
  PrincipalSubjectFirst:"Principal Subject First",
  PrincipalSubjectSecond:"Principal Subject Second",
  Print:"Print",
  ProfileStatus:"Profile Status",
  RefreshCaptcha:"Refresh Captcha",
  //RegisterHere:"Admission Year 2021-22 Student Registration",
  RegisterHere:"New Student Registration ",
 // RegisterWithPRNHere:"Admission Year 2020-21 Old Student Registration",
  RegisterWithPRNHere:"Old Student Registration",
  EnrolmentManualForm:"Enrolment Manual Form",
  OnlinePaymentManual:"Online Payment Manual",
  StandardShcedule:"11th Std Sci & Com Admission Schedule",
  InstructionforEnrolment:"Instruction for Enrolment",
  RegisteredForVoter:"Registered For Voter",
  RegisteredForVoterList:"Registered For Voter List?",
  RegistrationType:"Registration Type",
  RegularFees:"Regular Fees",
  Religion:"Religion",
  Remove:"Remove",
  RemoveFile : "Remove certificate",
  Edit:"Edit",
  RequestDetails:"RequestDetails",
  RequestedCenter:"Requested Center",
  RequestedCollege:"Requested College",
  RequestedSpecialization:"Requested Specialization",
  ResendOTP:"Resend OTP",
  ResultDate:"Result Date",
  RevaluationApplicationStatus:"Revaluation Application Status",
  ReVerificationApplicationStatus:"Re-Verification Application Status",
  Save:"Save",
  SeatNo:"Seat No",
  SeatNoRollNoLastExam:"Seat No./Roll No. (Last Exam)",
  Select:"Select",
  SelectCenterToChange:"Select Center To Change",
  SelectCollegeToChange:"Select College To Change",
  SelectCollegeToTransfer:"Select College To Transfer",
  SelectSpecializationToChange:"Select Specialization To Change",
  SelectedColleges:"Selected Colleges",
  SelectedSubjects:"Selected Subjects",
  SocialReservation:"Social Reservation",
  SpecializationIfApplicable:"Specialization (If Applicable)",
  SpecializationChangeRemark:"Specialization Change Remark",
  SpecializationTotalTHPR:"Specialization Total (TH+PR)",
  SpecializationSubject:"Specialization/Subject",
  Sports:"Sports",
  Stage1:"Stage 1",
  Stage2:"Stage 2",
  Stage3:"Stage 3",
  State:"State",
  Status:"Status",
  StudentDetails:"Student Details",
  StudentName:"Student Name",
  PRNCINNo:"College SPAN/CIN Number./ Regd.No.",
  StudentPhoto:"Student Photo",
  StudentRegionalName:"Student Regional Name",
  HSCMarkSheetName:"HSC MarkSheet Name",
  StudentSeatNO:"Student Seat NO",
  StudentSign:"Student Sign",
  StudentType:"Student Type",
  SyllabusGroup:"Syllabus Group",
  Tahsil:"Tahsil",
  TotalAmount:"Total Amount",
  TotalFees:"Total Fees",
  TotalMarksObtained:"Total Marks Obtained",
  Type:"Type",
  TypetheAboveText:"Type the Above Text",
  University:"University",
  UniversityFees:"University Fees",
  UniversityToMigrate:"University To Migrate",
  UniversityBoard:"University Board",
  UploadPhoto:"Upload Photo",
  UrbanRuralType:"Urban Rural Type",
  UserName:"User Name",
  VerificationApplicationStatus:"Verification Application Status",
  VerifyOTP:"Verify OTP",
  VisaNumber:"Visa Number",
  VisaValidity:"Visa Validity",
  YearofPassing:"Year of Passing",
  YearofPassingAppear:"Year of Passing Appear",
  YearTotalTHPR:"Year Total (TH+PR)",
  Yes:"Yes",
  YourFees:"Your Fees",
  PersonalInfoI:"Personal Info I",
  PersonalInfoII:"Personal Info II",
  PhotoAndSignature:"Photo And Signature",
  EducationalDetails:"Educational Details",
  CommonDocuments:"Common Documents",
  AreaofLocation:"Area of Location",
  VoterID:"Voter ID",
  AddUpdatePreviousExamDetails:"Add/Update Previous Exam Details",
  PreviousExamDetails:"Previous Exam Details",
  CompanyDetails:"Company Details",
  Name:"Name",
  ProfilePreview:"Profile Preview",
  Youcanselectonly:"You can select only",
 
  CoursePerSemester:"Course Per Semester",
  Prefix:"Prefix ",
  Examination:"Examination",
  ThirdSem:"3rd Sem",
  FourthSem:"4th Sem",
  GraceNoteDetail:"Total 5 marks are allowed for grace",
  GraceNote:"Note :",
  ToPass:"To Pass",
  Height:"Height(In cm)",
  Weight:"Weight(In kg)",
  Chest:"Chest(In cm)",
  MotherTongueTyping:"Mother Tongue Typing",
  MotherTongueTypingSpeed:"Typing Speed(Wpm)",
  EnglishTyping:"English Typing",
  StenoTypingSpeed:"Typing Speed(Wpm)",
  EnglishTypingSpeed:"Typing Speed(Wpm)",
  StenoTyping:"Steno Typing", 
  MSCIT:"MSCIT", 
  MSCITYear:"MSCIT Year", 
  MSCITGrade:"MSCIT Grade", 
  MedicalCertificate :"Medical Certificate",
  OthCourseName :"Course Name",
  OthCourseAuthority :"Course Authority",
  OthCourseYear :"Passing Year",
  OthCourseGrade :"Grade",
  OthCourseCert :"Course Certificate",
  ApptitudeTest:"Apptitude Test",
  GroupDiscussion:"Group Discussion",
  TechnicalInterview:"Technical Interview",
  HRInterview:"HR Interview", 
  FinalSelection:"Final Selection",
  CategoryRequired:"Required For Category",
  SubjectReuired:"Required For Category",
  ReqiuredGraceSameForSubjectAndCategory:"Same Required for Category & Subject",

  SPINSTR1:"Your Mobile OTP verification is Pending. Kindly Enter last OTP received and click on 'Verify OTP' button to verify Mobile OTP.",
  SPINSTR2:"Instructions For Candidate:-",
  SPINSTR3:"Verify One Time Password (OTP)",
  SPINSTR4:"Portal will send One Time Password (OTP) on your Mobile and Email ID.",
  SPINSTR5:"Mobile OTP is not received in 60 sec,Resend OTP and Enter last OTP Received.",
  SPINSTR6:"Submit button will be enabled after OTP Verification.",
  SPINSTR7:"On Successful Registration, CandIDate can login with Email ID as User ID and Password to complete Student Profile & Application Form.",
  SPINSTR8:"Important Instruction:-",
  SPINSTR9:"Ensure Name Entered is as per Last Qualified Exam Marksheet / Certificate.",
  SPINSTR10:"Kindly note down your User ID and Password for all future logins.",
  SPINSTR11:"CandIDate is advised not to disclose or share their User ID  and Password with anybody.",
  SPINSTR12:"After Login Candidate can change their Password.",
  SPINSTR13:"Ensure to Log out at the end of session, so that details cannot be tampered or modified.",
  SPINSTR14:"OTP has sent to your Email. Please Check",
  SPINSTR15:"Are You a Student of this University?",
  SPINSTR16:"OTP has sent to your Mobile No. Please Check",
  SPINSTR17:"Double click on row to view Application status,Print Application Form,Hall Ticket and Payment receipt.",
  SPINSTR18:"Your Profile already Locked",
  SPINSTR19:"Do you want to Lock your Profile?",
  SPINSTR20:"Do you want to Cancel Application?",
  SPINSTR21:"Your Profile is incomplete can't Lock Profile",
  SPINSTR22:"Max File Size Allowed",
  SPINSTR23:"Only JPEG and PNG File type allowed.",
  SPINSTR24:"Double click on Row to Add,Delete,Modify Record.",
  SPINSTR25:"SSC and HSC or Diploma Details are Mandatory.",
  SPINSTR26:"Please Select Specialization/Subject at your Graduation Level Applicable",
  SPINSTR27:"To apply For M.Sc Chemistry: you should have B.Sc with Chemistry is one of the optional subject.",
  SPINSTR28:"To apply For M.Sc Zoology  : you should have B.Sc with Zoology is one of the optional subject.",
  SPINSTR29:"If you do not have Specialization Please select General option.",
  SPINSTR30:"Please Update Your Marks when Available",
  SPINSTR31:"Please Enter Your Yearly Total Marks and Specialization Subject Marks (Semester 1 + Semester 2) Below. Marks of Year I &  II are Compulsory",
  SPINSTR32:"Only pdf/jpg file can be uploaded.",
  SPINSTR33:"Maximum File Size of 1MB allowed per upload.",
  SPINSTR34:"Your Profile is incomplete can't Submit",
  SPINSTR35:"You need to lock Profile from Dashboard before Application Form Submission",
  SPINSTR36:"Please Read Prospectus,Notification and etc before applying Online",
  SPINSTR37:"Program to Apply (Based on your Education Qualification & Download Prospect following Programs are recommended for you)",
  SPINSTR38:"Note:",
  SPINSTR39:"Do you want to Submit Application Form?",
  SPINSTR40:"You have already paid",
  SPINSTR41:"Do you want to Submit Application Form and Proceed for Payment?",
  SPINSTR42:"Do you want to Proceed for Payment?",
  SPINSTR43:"Submitted Successfully. Go to College/Univiersity for Cash/DD/Cheque Payment",
  SPINSTR44:"Your Payment Transaction in Process please wait...",
  SPINSTR45:"Your Payment Transaction is successfull, your Transcation Number is",
  SPINSTR46:"Your Payment Transaction is failure, your Transcation Number is",
  SPINSTR47:"Your Payment Transaction in Process...",
  SPINSTR48:"Please close Form and check again...",
  SPINSTR49:"Note : Once You Submit request,you are not allowed to modify the request",
  SPINSTR50:"Note : Once You Paid Fee,you are not allowed to cancel the request",
  SPINSTR51:"Note : Once You Submit request,you are not allowed to modify/cancel the request",
  SPINSTR52:"You can select only",
  SPINSTR53:"Course Per Semester",
  SPINSTR54:"Recommended browser: Later versions from Google Chrome 25",
  SPINSTR55:"Support Email ID: e_support@uaems.com",
  SPINSTR56:"Student Portal",
  SPINSTR57:"Welcome to the University Admissions & Examinations Management System (UAEMS) online admission process in Campus/Sub Campuses.",
  SPINSTR58:"To Apply, you would have to first complete the Registration Process.",
  SPINSTR59:"Using your User ID and Password you can login and complete the Student Profile.",
  SPINSTR60:"Using your User ID and Password you can login and complete the Application Form",
  SPINSTR61:"If found wrong information filled, University is liable to reject any registration can take legal action.",
  SPINSTR62:"For Information regarding course details, entrance examination schedule visit university website.",
  SPINSTR63:"Information regarfding the filling of online form, Application Status will be available on the https://uaems.com website. ",
  SPINSTR64:"You must agree to abide the rules and regulations, undertakings, information uploaded on the website for the given batch.",
  SPINSTR65:"All disputes in this regard are subjected to the legal jurisdiction of Maharashtra.",
  SPINSTR66:"Instructions",
  SPINSTR67:"Please enter your Login ID and Password you have used during Registration",
  SPINSTR68:"You are advised not to disclose or share your password with anybody.",
  SPINSTR69:"Only Authorized users can proceed further.",
  SPINSTR70:"Your IP Address and other information will be captured for security reasons.",
  SPINSTR71:"For Course detail and exam schedule visit University link bellow ",
  SPINSTR72:"At any point of time if you face difficulty/hindrance in completing the Online Process please feel free to contact from your Registered Mobile No. On Toll Free No.",
  SPINSTR73:"Thank You",
  SPINSTR74:"UAEMS Team",
  SPINSTR75:"Toll Free No: 18002662998",
  SPINSTR76:"Timing : 9:30 AM to 6.30 PM",
  SPINSTR77:"Screen Reader",
  SPINSTR78:"Don't have an Account?",
  SPINSTR79:"Please ensure that you have following information required for application, ready in your hand before you proceed.",
  SPINSTR80:"I have my own valid Email ID and Mobile No. and I am sole user same.",
  SPINSTR81:"I have soft copy of my passport size color photograph (scanned with min.72 to max.150 dpi).",
  SPINSTR82:"I have Proof of Date of Birth (D.O.B.) (Aadhar Card, PAN card, School Leaving, Driving License)",
  SPINSTR83:"Physical availability of Mobile Phone for OTP.",
  SPINSTR84:"I have Caste Certificate / Caste validity certificate / Non-Creamy Layer for Backward Class.",
  SPINSTR85:"I have Marksheet/Passing Certificate for Qualifying exam.",
  SPINSTR86:"I have Gazette Notification (if Name of documents are different than the name in which you want to apply)",
  SPINSTR87:"Online Net Banking/Debit Card /Credit Card details",
  SPINSTR88:"I am submitting all the above which may include other personally identifiable information, voluntarily. I am fully aware that Colleges, University, Government, their associated agencies and their employees will use this information for Academic, Administrative, Research, Internal Quality Audits and Legal purposes and I am authorizing them for the same.",
  SPINSTR89:"I authorize University to send text messages to my Mobile phone from time to time to convey Academic and Administrative Information.",
  SPINSTR90:"I have read the Prospectus and rules about Admission, thus clicking the below ‘Confirm’ button.",
  SPINSTR91:"I am in valid possession of above mentioned documents and I have read the Prospectus of academic program and I have satisfied myself that I am eligible for the applying program.",
  SPINSTR92:"I have self registered on Portal with my own Email ID and Mobile No.",
  SPINSTR93:"I have updated Student Profile’s relevant sections with accurate information after self Registration. Information provided Student Profile is final.",
  SPINSTR94:"I have my own valid Email Id and Mobile No. mentioned during self registration.",
  SPINSTR95:"I have Marks and Mark list of the examination I have passed.",
  SPINSTR96:"I have Mark sheet of Qualifying Exam.",
  SPINSTR97:"I have Passing Certificate of Qualifying Exam.",
  SPINSTR98:"I am Paying Cash/DD/Cheque at College/University.",
  SPINSTR99:"You can Only set ",
  SPINSTR100:"Once you submit, you cannot modify it",
  SPINSTR101:"Successfully Registered , Do you want to Continue for Apply for scholarships?",
  ApplicationTitle:"Abdul Kalam College",
  IntegratedUniversityManagementSystem:"Integrated University Management System",
  Typetheabovetext:"Type the above text",
  Donthaveanaccount:"Don't have an account?",
  SelectLanguage:"Select Language",
  AdmissionStatus:"Admission Status",
  EligibilityStatus:"Eligibility Status",
  EligibilityDateRemark:"Eligibility Date With Remark",
  ApprovalDateRemark:"Approval Date With Remark",
  ApprovedStatus:"Approval Status",
  GeneralMerit: "General",
  PhysicalHandicapMerit: "PH Merit",
  SocialReservationMerit: "Social Reservation",
  CasteMerit: "Caste",
  FemaleMerit: "Female",
  SubmissionDate:"Submission Date",
  HallTicketGeneration:"Hall Ticket Generation",
  HallTicketNo:"Hall Ticket No ",
  EnteranceExamAttendance:"Enterance Exam Attendance",
  EntranceResult:"Entrance Result",
  AllotmentStatus: "Allotment Status",
  Logout: "Logout",
  TollFreeNo:"Toll Free No",
  Preference:"Preference",
  UniversityAdmissionsExaminationManagement:"University Admissions & Examinations Management System",
  SyllabusGroupINS:"Maximum subject you can select",
  ExamGroup:"Exam Group",
  ExamResult:"Exam Result",
  ViewResult:"View Result",
  PrintHallTicket:"Print Hall Ticket",
  BuildingName:"Building Name",
  RoomNo:"Room No.",
  BedNo:"Bed No.",
  MessApplicable:"Mess Applicable",
  RoomTypeName:"Room Type",
  HostelDetails:"Hostel Details",
  PrevPercentage:"Previous %",
  StudentLevel:"Educational Level",
  Facilities:"Facilities",
  HostelType:"Hostel Type",
  PlacementCompanyRequirementDetail:"Placement Company Requirement Detail",
  CompanyName:"Company Name",
  DesignationName:"Designation Name",
  JobLocation:"Job Location",
  NoOfPosts:"No Of Posts",
  CompanyAddress:"Company Address", 
  WebURL:"Web URL",
  TelephoneNo:"Telephone No.", 
  RequiredSkillSet:"Required Skill Set",
  SalaryOffered:"Salary Offered",
  NoOfYearsBond:"No Of Years Bond", 
  FeesHead:"Fees Head",
  OnLinePaymentTransactionID:"Transaction No.",
  PaymentDate:"Payment Date",
  NoOfInstallment:"No Of Installment",
  PaymentDetails:"Payment Details",
  PendingFees:"Pending Fees",
  InstallmentFees:"Installment Fees",
  PayableAmount:"Payable Amount",
  ScholarshipName:"Scholarship Name",
  AppliedForAnyStateOrNationalScholarship:"Applied For Any State Or National Scholarship ?",
  CurrentProgramDetails:"Current Program Details",
  LastYearExamDetails:"Last Year Exam Details",
  FromDate:"From Date",
  NotificationDate:"Notification Date",
  ToDate:"To Date",
  ApplyFromDate:"From Date",
  ApplyTillDate:"To Date",
  ScholarshipDetail:"Scholarship Detail:",
  ScholarshipAppliedDetail:"Scholarship Applied Detail",
  ScholarshipRegistrationDetail:"Scholarship Registration Detail",
  ScholarshipCategory:"Scholarship Category",
  ApplyForScholarship:"Apply For Scholarship",
  UrbanRuralTypeName:"Urban Rural Type",
  FatherIsAlive:"Father Is Alive ?",
  MotherIsAlive:"Mother Is Alive ?",
  ApplicantIsEldestInTheFamily:"Applicant Is Eldest In The Family ?",
  FamilyIsDependentOnApplicant:"Family Is Dependent On Applicant ?",
  ApplicantIsStudyingInNightCollege:"Applicant Is Studying In Night College ?",
  SportName: "Sport Name",
  SportDate: "Sport Date",
  PlaceName: "Place Name",
  PerformanceType: "Performance Type",
  Level: "Level",
  Rank: "Rank",
  Marks:"Mark",
  TotalMarks:"Total Mark",
  GradePoints:"Gd.Pt",
  ObtGradePoints:"Obt Gd.Pt",
  FeedbackCategory:"Feedback Category",
  QuestionDescription:"Question Description",
  ProspectusFees:"Prospectus Fees",
  ProgramType:"Program Type",
  Medium:"Medium",
  ProspectInstruction:"Download Course Prospect.",
  ViewInstruction:"View Instruction",
  GoToProfile:"Go To Profile",
  GoToLogIn:"Go To LogIn",
  IAgreeText:" I Agree",
  Applycourseforview:"As per your Education Qualification Eligible Programs View",
  ProspectScheduleStartDate:" Start dt.",
  ProspectScheduleEndDate:" End dt.",
  Student:"Student",
  CertificateTitle:"Certificate Title",
  CertificateAuthority:"Certificate Authority",
  Subject:"Subject",
  PurposeName:"Purpose Name",
  Narration:"Narration",
  ReceiptNo:"Receipt No",
  SchoolUdise:"School UDIS",
  SaralID:"Saral ID",
  AadharNoID:"Student Aadhar No.",
  ABCID:"ABC ID",
  SupportContacts:"Support Contacts",
  AcedemicYear:"Acedemic Year",
  ISExternalStudent:"Not Applying For First Year",
  BirthPlace:"Birth Place", 
  BirthThasil:"Birth Tahsil",
  BirthDistrict:"Birth District",
  BirthState:"Birth State",
  BirthCountry:"Birth Country",
  LoginAS:"Login AS",
  InstructionForSelfRegistration:"Instruction For Self Registration",
  GrievanceSubmission:"Grievance Submission",
  GrievanceType:"Grievance Type",
  Date:"Date",
  SelectFile:"Select File",
  ActionTaken:"Action Taken",
  Feedback:"Feedback",
  Division:"Division",
  RecessTime:"Recess Time",
  WeeklyOff:"Weekly Off",
  SlotTime:"Slot Time",
  Monday:"Monday",
  Tuesday:"Tuesday",
  Wednesday:"Wednesday",
  Thursday:"Thursday",
  Friday:"Friday",
  Saturday:"Saturday",
  Sunday:"Sunday",
  Show:"Show",
  Day:"Day",
  Teacher:"Teacher",
  HolidayDescription:"Holiday/Sunday"
}]
let MarathiList: LanguageList[]=[{
  Program:"अभ्यासक्रम",
  StartDate:"प्रारंभ तारीख",
  EndDate:"शेवटची तारीख",
  Apply:"अर्ज करा",
  LateDate:"उशीरा तारीख",
  ApplicationNO:"अर्ज क्र.",
  Paymentstatus:"पैसे भरल्याची स्थिती",
  ApprovedLevel:"मंजूर स्तर",
  Download:"डाउनलोड करा",
  PRNNO:"नाॊंदणी क्रमांक.",
  ApplicationDate:"अर्जाची तारीख",
  ProgramDetails:"अभ्यासक्रम तपशील",
  Pattern:"नमुना",
  Specialization:"विशेषीकरण",
  SemPart:"सत्र/भाग",
  SemPartNO:"सत्र भाग क्रमांक",
  College:"महाविद्यालय",
  Fees:"शुल्क",
  DocumentName:"दस्तऐवज नाव",
  FeeDetails:"फी तपशील",
  View:"पहा",
  Upload:"अपलोड करा",
  Submit:"सबमिट करा",
  Cancel:"रद्द करा",
  PrintForm:"प्रिंट फॉर्म",
  PayOnline:"ऑनलाईन पे करा",
  PrintReceipt:"पावती प्रिंट करा",
  Close:"बंद",
  BonafideCertificate:"बोनाफाईड प्रमाणपत्र",
  PrefixSalutation:"उपसर्ग/अभिवादन",
  LastName:"आडनाव",
  FirstName:"पहिले नाव",
  FatherHusbandName:"वडिलांचे / पतीचे नाव",
  FullName:"पूर्ण नाव",
  Gender:"लिंग",
  DateofBirth:"जन्म तारीख",
  Age:"वय",
  MobileNo:"मोबाईल क्रमांक",
  EmailID:"ईमेल आयडी",
  Next:"पुढे",
  AccountNo:"खाते क्रमांक.",
  Accepted:"स्वीकारा",
  NotAccepted:"स्वीकार नाही",
  AddNew:"नवीन जोडा",
  Address:"पत्ता",
  Address1:"पत्ता 1",
  Address2:"पत्ता 2",
  Address3:"पत्ता 3",
  AddressDetails:"पत्ता तपशील",
  AdmissionFor:"साठी प्रवेश",
  AdmissionMethod:"प्रवेश पद्धत",
  AdmissionSchedule:"प्रवेश वेळापत्रक",
  AdmissionStartDate:"प्रवेश प्रारंभ तारीख",
  AdmissionType:"प्रवेश प्रकार",
  ApplicationCancel:"अर्ज रद्द करा",
  ApplicationNo:"अर्जाची तारीख अर्ज क्रमांक",
  ApplicationStatus:"अर्जाची स्थिती",
  ApplicationForm:"अर्ज ",
  Back:"बॅक",
  BackToLogin:"लॉगिन कडे परत",
  BankBranchName:"बँकेच्या शाखेचे नाव",
  BankDetails:"बँक तपशील",
  BankName:"बँकेचे नाव",
  BloodGroup:"रक्त गट",
  Board:"मंडळ",
  ByDate:"तारखेनुसार",
  Caste:"जात",
  Category:"श्रेणी",
  CategoryFees:"श्रेणीनुसार फी",
  Center:"केंद्र",
  CenterChangeRemark:"केंद्र बदला शेरा",
  CGPA:"सीजीपीए",
  SGPA:"SGPA",
  City:"शहर",
  CityProvince:"शहर / प्रांत",
  CityTownVillage:"शहर / नगर / गाव",
  Code:"सांकेतिक कोड",
  CollegeChangeRemark:"कॉलेज बदल टिप्पणी",
  CurrentCollege :"करंट कॉलेज",
  CollegeFees:"महाविद्यालय शुल्क",
  CollegeToMigrate:"महाविद्यालयात स्थलांतर करा",
  CollegeInstitute:"महाविद्यालय / संस्था",
  Compulsory:"अनिवार्य",
  ConfirmPassword:"संकेतशब्दाची पुष्टी करा",
  Confirmation:"पुष्टीकरण",
  Continue:"सुरू",
  CorrespondenceAddress:"पत्रव्यवहाराचा पत्ता",
  Country:"देश",
  Course:"विषय",
  CourseCode:"विषय सांकेतिक कोड",
  CourseDetails:"विषय तपशील",
  CourseNameObtainedMarks:"विषयचे नाव (प्राप्त गुण)",
  MarksheetFile1:"शेवटचे वर्ष / सेम मार्कशीट 1",
  MarksheetFile2:"शेवटचे वर्ष / सेम मार्कशीट 2",
  PaymentReceiptFile:"भरपाईची पावती",
  PaymentReceiptFileExternal:"भरपाईची पावती",
  Delete:"डीलीट",
  Description:"शेरा वर्णन",
  Details:"तपशील",
  District:"जिल्हा",
  DrivingLicenceNo:"वाहन चालविण्याचा परवाना क्रमांक",
  EducationType:"शिक्षणाचा प्रकार",
  EducationalStream:"शैक्षणिक प्रवाह",
  EnrollmentFormDate:"नोंदणी फॉर्मची तारीख",
  EnterEmailOTP:"ईमेल ओटीपी प्रविष्ट करा",
  EnterOTP:"ओटीपी प्रविष्ट करा",
  EntranceExamFlag:"प्रवेश परीक्षा ध्वज",
  Exam:"परीक्षा",
  ExamFormDate:"परीक्षा फॉर्म तारीख",
  ExamFormFees:"परीक्षा फॉर्म फी",
  ExamInstance:"परीक्षा सत्र",
  FatherHusbandGuardianLastName:"वडील / पती / पालक आडनाव",
  FatherHusbandGuardianMiddleName:"वडील / पती / पालक मधले नाव",
  FatherHusbandGuardianName:"वडील / पती / पालकांचे नाव",
  FeesAmount:"शुल्क रक्कम",
  File1:"फाईल 1",
  Find:"फाईंड",
  ForeignAddress:"परदेशी पत्ता",
  ForgotPassword:"संकेतशब्द विसरलात?",
  FormNo:"फॉर्म क्रमांक",
  GenerateOTP:"ओटीपी व्युत्पन्न करा",
  Grade:"श्रेणी",
  GradeClass:"श्रेणी / वर्ग",
  GuardianOccupation:"पालकांचा व्यवसाय",
  GuardianParentMobileNo:"पालक मोबाईल क्रमांक",
  GuardianParentPhoneNo:"पालक फोन क्रमांक",
  Hobby:"छंद",
  IfMinorityPleaseSelect:"जर अल्पसंख्याक असेल तर? कृपया निवडा",
  IFSCCode:"आयएफएससी कोड",
  InformMessage:"संदेश कळवा",
  IsPermanentAddresssameasCorrespondenceAddress:"स्थायी पत्ता पत्रव्यवहाराच्या पत्त्यासारखा आहे का?",
  LastDateofFormSubmission:"फॉर्म जमा करण्याची अंतिम तारीख",
  LateFees:"उशिराचे शुल्क",
  ListofColleges:"महाविद्यालयांची यादी",
  Login:"लॉगिन",
  MaritalStatus:"वैवाहिक स्थिती",
  MiddleName:"मधले नाव",
  MoblieOTP:"मोबाइल ओटीपी",
  MonthofPassing:"उत्तीर्ण महिना",
  MonthofPassingAppear:"उत्तीर्ण होण्याचा / परीक्षा दिली महिना",
  MotherLastName:"आईचे आडनाव",
  MotherMiddleName:"आई मधले नाव",
  MotherTongue:"मातृभाषा",
  MothersName:"आईचे नाव",
  NameofSchoolCollege:"शाळा / महाविद्यालयाचे नाव",
  Nationality:"राष्ट्रीयत्व",
  NewMarks:"नवीन गुण",
  NewPassword:"नवीन संकेतशब्द",
  NewStudentName:"नवीन विद्यार्थ्यांचे नाव",
  PRNCINNo:"कॉलेज स्पॅन / सीआयएन क्रमांक/नोंदणी क्रमांक",
  No:"नाही",
  ObtainedMarks:"मिळालेले गुण",
  ObtMarks:"मिळालेले गुण",
  OK:"ओके",
  OldPassword:"जुना संकेतशब्द",
  OpenCategoryFees:"खुला प्रवर्ग श्रेणी शुल्क रक्कम",
  OtherCaste:"इतरजात",
  OtherStatus:"इतर स्थिती",
  Outof:"एकूण गुण",
  OutofMarks:"एकूण गुण",
  PANCardNo:"पॅन कार्ड क्रमांक",
  Password:"संकेतशब्द",
  PassingMonth:"उत्तीर्ण महिना",
  Payment:"पेमेंट",
  PaymentMode:"भरण्याची पध्दत",
  PaymentStatus:"पैसे भरल्याची स्थिती",
  OfferStatus:"ऑफर स्थिती",
  Percentage:"टक्केवारी",
  PermanentAddress:"कायमचा पत्ता",
  PhotoCopyApplicationStatus:"फोटो कॉपी अर्ज स्थिती",
  PhysicalDisability:"शारीरिक अपंगत्व",
  PinCode:"पिन कोड",
  PreviousExamDegree:"मागील परीक्षा / पदवी",
  PreviousCollege :"मागील कॉलेज",
  PreviousProgram:"मागील अभ्यासक्रम",
  PrincipalSubjectFirst:"मुख्य विषय प्रथम",
  PrincipalSubjectSecond:"मुख्य विषय दुसरा",
  Print:"प्रिंट",
  ProfileStatus:"प्रोफाइल स्थिती",
  RefreshCaptcha:"रीफ्रेश कॅप्चा",
  RegisterHere:"नवीन विद्यार्थी नोंदणी येथे क्लिक करा",
  RegisterWithPRNHere:"जुने विद्यार्थी नोंदणी. येथे क्लिक करा", 
  EnrolmentManualForm:"नावनोंदणी मॅन्युअल फॉर्म", 
  OnlinePaymentManual:"ऑनलाईन पेमेंट मॅन्युअल",
  StandardShcedule:"अकरावी विज्ञान व कॉम प्रवेश वेळापत्रक",
  InstructionforEnrolment:"नावनोंदणीसाठी सूचना",
  RegisteredForVoter:"मतदार नोंदणीकृत",
  RegisteredForVoterList:"मतदार यादीसाठी नोंदणीकृत?",
  RegistrationType:"नोंदणी प्रकार",
  RegularFees:"नियमित फी",
  Religion:"धर्म",
  Remove:"काढा",
  RemoveFile:"फाईल काढा",
  Edit:"सुधारीत करा",
  RequestDetails:"विनंती तपशील",
  RequestedCenter:"विनंती केलेले केंद्र",
  RequestedCollege:"विनंती केलेले कॉलेज",
  RequestedSpecialization:"विनंती केलेले विशेषीकरण",
  ResendOTP:"ओटीपी पुन्हा पाठवा",
  ResultDate:"निकालाची तारीख",
  RevaluationApplicationStatus:"पुनर्मूल्यांकन  अर्ज स्थिती",
  ReVerificationApplicationStatus:"पुन्हा सत्यापन अर्ज स्थिती",
  Save:"सेव्ह",
  SeatNo:"आसन क्रमांक",
  SeatNoRollNoLastExam:"आसन क्रमांक (अंतिम परीक्षा) / रोल क्रमांक",
  Select:"निवडा",
  SelectCenterToChange:"बदलण्यासाठी केंद्र निवडा",
  SelectCollegeToChange:"बदलण्यासाठी महाविद्यालय निवडा",
  SelectCollegeToTransfer:"हस्तांतरणासाठी कॉलेज निवडा",
  SelectSpecializationToChange:"बदलण्यासाठी विशेषीकरण निवडा",
  SelectedColleges:"निवडलेली महाविद्यालये",
  SelectedSubjects:"निवडलेले विषय",
  SocialReservation:"सामाजिक आरक्षण",
  SpecializationIfApplicable:"विशेषीकरण (लागू असल्यास)",
  SpecializationChangeRemark:"विशेषीकरण बदल शेरा / नोंद",
  SpecializationTotalTHPR:"विशेषीकरण एकूण (लेखी +प्रात्यक्षिक)",
  SpecializationSubject:"विशेषीकरण/विषय",
  Sports:"खेळ",
  Stage1:"टप्पा 1",
  Stage2:"टप्पा 2",
  Stage3:"टप्पा 3",
  State:"राज्य",
  Status:"स्थिती",
  StudentDetails:"विद्यार्थ्यांचा तपशील",
  StudentName:"विद्यार्थ्याचे नाव",
  StudentPhoto:"विद्यार्थ्यांचा फोटो",
  StudentRegionalName:"विद्यार्थी प्रादेशिक नाव",
  HSCMarkSheetName:"एचएससी मार्कशीटचे नाव",
  StudentSeatNO:"विद्यार्थी आसन क्रमांक",
  StudentSign:"विद्यार्थ्यांची सही",
  StudentType:"विद्यार्थ्यांचा प्रकार",
  SyllabusGroup:"अभ्यासक्रम गट",
  Tahsil:"तहसील",
  TotalAmount:"एकूण रक्कम",
  TotalFees:"एकूण शुल्क रक्कम",
  TotalMarksObtained:"एकूण प्राप्त गुण",
  Type:"प्रकार",
  TypetheAboveText:"वरील मजकूर टाइप करा",
  University:"विद्यापीठ",
  UniversityFees:"विद्यापीठ शुल्क",
  UniversityToMigrate:"स्थलांतर करण्यासाठी विद्यापीठ",
  UniversityBoard:"विद्यापीठ / मंडळ",
  UploadPhoto:"फोटो अपलोड करा",
  UrbanRuralType:"शहरी ग्रामीण प्रकार",
  UserName:"वापरकर्त्याचे नाव",
  VerificationApplicationStatus:"सत्यापन अर्ज स्थिती",
  VerifyOTP:"ओटीपी प्रमाणित करा",
  VisaNumber:"व्हिसा क्रमांक",
  VisaValidity:"व्हिसा वैधता",
  YearofPassing:"उत्तीर्ण वर्ष",
  YearofPassingAppear:"उत्तीर्ण /परीक्षा दिली वर्ष",
  YearTotalTHPR:"वर्ष एकूण (लेखी +प्रात्यक्षिक)",
  Yes:"होय",
  YourFees:"आपले शुल्क",
  PersonalInfoI:"वैयक्तिक माहिती I",
  PersonalInfoII:"वैयक्तिक माहिती II",
  PhotoAndSignature:"फोटो आणि स्वाक्षरी",
  EducationalDetails:"शैक्षणिक तपशील",
  CommonDocuments:"सामान्य कागदपत्रे",
  AreaofLocation:"स्थानाचे क्षेत्र",
  VoterID:"मतदार ओळखपत्र",
  AddUpdatePreviousExamDetails:"मागील परीक्षेचा तपशील जोडा/अद्यतनित करा",
  PreviousExamDetails:"मागील परीक्षेचा तपशील",
  CompanyDetails:"कंपनी तपशील",
  Name:"नाव",
  ProfilePreview:"प्रोफाइल पूर्वावलोकन",
  Youcanselectonly:"कोर्स प्रति सेमिस्टर",
  CoursePerSemester:"आपण फक्त निवडू शकता",
  Prefix:"उपसर्ग ",
  Examination:"परीक्षा",
  ThirdSem:"3 रा सेम",
  FourthSem:"चौथा सेम",
  GraceNoteDetail:"ग्रेससाठी एकूण ५ गुणांना परवानगी आहे",
  GraceNote:" नोट :",
  ToPass:"पास",
  Height:"उंची (In cm)",
  Weight:"वजन(In kg)",
  Chest:"छाती(In cm)",
  MotherTongueTyping:"मातृभाषा टायपिंग",
  MotherTongueTypingSpeed:"टायपिंग वेग(Wpm)",
  EnglishTyping:"मातृभाषा टायपिंग",
  StenoTypingSpeed:"टायपिंग वेग (Wpm)",
  EnglishTypingSpeed:"टायपिंग वेग (Wpm)",
  StenoTyping:"स्टेनो टायपिंग", 
  MSCIT:"एमएससीआयटी", 
  MSCITYear:"एमएससीआयटी वर्ष", 
  MSCITGrade:"एमएससीआयटी ग्रेड", 
  MedicalCertificate :"वैद्यकीय प्रमाणपत्र",
  OthCourseName:"कोर्सचे नाव",
  OthCourseAuthority:"कोर्स अथॉरिटी",
  OthCourseYear:"उत्तीर्ण वर्ष",
  OthCourseGrade:"ग्रेड",
  OthCourseCert:"कोर्स प्रमाणपत्र",
  ApptitudeTest:"Apptitude Test",
  GroupDiscussion:"Group Discussion",
  TechnicalInterview:"Technical Interview",
  HRInterview:"HR Interview", 
  FinalSelection:"Final Selection",

  CategoryRequired:"Required For Category",
  SubjectReuired:"Required For Category",
  ReqiuredGraceSameForSubjectAndCategory:"Same Required for Category & Subject",
  

SPINSTR1:"आपले मोबाइल ओटीपी सत्यापन प्रलंबित आहे. कृपया प्राप्त झालेला अंतिम ओटीपी प्रविष्ट करा आणि मोबाइल ओटीपी सत्यापित करण्यासाठी 'सत्यापित ओटीपी' बटणावर क्लिक करा.",
SPINSTR2:"उमेदवारास सूचना: -",
SPINSTR3:"वन टाईम पासवर्ड (ओटीपी) सत्यापित करा",
SPINSTR4:"पोर्टल आपल्या मोबाइल आणि ईमेल आयडी वर वन टाईम पासवर्ड (ओटीपी) पाठवेल.",
SPINSTR5:"मोबाइल OTP 60 सेकंद मिळाले नाही तर, OTP परत पाठवा आणि गेल्या OTP प्राप्त प्रविष्ट करा.",
SPINSTR6:"सबमिट बटण ओटीपी पडताळणीनंतर सक्षम होईल.",
SPINSTR7:"यशस्वी नोंदणीनंतर, विद्यार्थी प्रोफाइल आणि अनुप्रयोग फॉर्म पूर्ण करण्यासाठी उमेदवार ईमेल आयडी व वापरकर्ता आयडी व संकेतशब्द म्हणून लॉग इन करू शकतात.",
SPINSTR8:"महत्त्वपूर्ण सूचना: -",
SPINSTR9:"अंतिम पात्रता परीक्षा मार्कशीट / प्रमाणपत्र नुसार नाव नोंदविलेले नाव असल्याची खात्री करा.",
SPINSTR10:"कृपया भविष्यातील सर्व लॉगिनसाठी आपला वापरकर्ता आयडी आणि संकेतशब्द लक्षात ठेवा.",
SPINSTR11:"उमेदवाराला सल्ला दिला आहे की त्यांचा यूजर आयडी व पासवर्ड कोणालाही सांगू नये किंवा सामायिक करू नये.",
SPINSTR12:"लॉगिन नंतर उमेदवार त्यांचा संकेतशब्द बदलू शकतात.",
SPINSTR13:"सत्राच्या शेवटी लॉग आउटची खात्री करा, जेणेकरून तपशीलांमध्ये छेडछाड किंवा बदल करता येणार नाही.",
SPINSTR14:"ओटीपीने आपल्या ईमेलला पाठविले आहे. कृपया तपासा",
SPINSTR15:"आपण या विद्यापीठाचे विद्यार्थी आहात का?",
SPINSTR16:"ओटीपीने तुमच्या मोबाइल नंबरवर पाठवले आहे. कृपया तपासा",
SPINSTR17:"अर्जाची स्थिती, प्रिंट अप्लिकेशन फॉर्म, हॉल तिकीट आणि पेमेंट पावती पाहण्यासाठी ओळीवर दोनदा क्लिक करा.",
SPINSTR18:"आपले प्रोफाइल आधीच लॉक केलेले आहे",
SPINSTR19:"आपण आपले प्रोफाइल लॉक करू इच्छिता?",
SPINSTR20:"आपण अर्ज रद्द करू इच्छिता?",
SPINSTR21:"आपले प्रोफाइल अपूर्ण आहे प्रोफाइल लॉक करू शकत नाही",
SPINSTR22:"कमाल फाइल आकार परवानगी",
SPINSTR23:"केवळ जेपीईजी आणि पीएनजी फाईल प्रकारास परवानगी आहे.",
SPINSTR24:"पंक्तीवर  दोनदा क्लिक करा रेकॉर्ड जोडा, हटविणे, सुधारित करण्यासाठी ",
SPINSTR25:"दहावी आणि बारावी किंवा डिप्लोमा तपशील अनिवार्य आहेत.",
SPINSTR26:"कृपया आपल्या पदवी स्तरावर लागू असलेले स्पेशलायझेशन / विषय निवडा",
SPINSTR27:"एम.एस्सी केमिस्ट्रीसाठी अर्ज करण्यासाठी: आपल्याकडे बी.एस.सी. केमिस्ट्री हा एक पर्यायी विषय असणे आवश्यक आहे.",
SPINSTR28:"एमएससी प्राणीशास्त्र अर्ज करण्यासाठी: आपल्याकडे बी.एस.सी. प्राणीशास्त्र  हा एक पर्यायी विषय असणे आवश्यक आहे.",
SPINSTR29:"आपल्याकडे स्पेशलायझेशन नसल्यास कृपया सामान्य पर्याय निवडा.",
SPINSTR30:"कृपया उपलब्ध झाल्यावर आपले गुण अद्यतनित करा",
SPINSTR31:"कृपया खाली आपले वार्षिक एकूण गुण आणि स्पेशलायझेशन सब्जेक्ट मार्क्स (सेमेस्टर 1 + सेमेस्टर 2) खाली द्या. वर्ष १ व २ चे गुण अनिवार्य आहेत",
SPINSTR32:"केवळ पीडीएफ फाईल अपलोड केली जाऊ शकते.",
SPINSTR33:"प्रति अपलोड जास्तीत जास्त 1MB फाइल आकार अनुमत आहे.",
SPINSTR34:"आपले प्रोफाइल अपूर्ण आहे सबमिट करू शकत नाही",
SPINSTR35:"अर्ज फॉर्म सबमिशनपूर्वी आपल्याला डॅशबोर्डवरून प्रोफाइल लॉक करणे आवश्यक आहे",
SPINSTR36:"ऑनलाईन अर्ज करण्यापूर्वी कृपया प्रॉस्पेक्टस, अधिसूचना वगैरे वाचा",
SPINSTR37:"प्रोग्राम प्रवेश कार्यक्रम निवड (आपल्या शैक्षणिक पात्रतेवर आधारित पुढील प्रोग्राम आपल्यासाठी शिफारस केली जातात)",
SPINSTR38:"टीपः",
SPINSTR39:"आपण अर्ज सबमिट करू इच्छिता?",
SPINSTR40:"आपण आधीच पैसे दिले आहेत",
SPINSTR41:"आपण अर्ज फॉर्म सबमिट करू आणि पेमेंटसाठी पुढे जाऊ इच्छिता?",
SPINSTR42:"आपण पेमेंटसाठी पुढे जाऊ इच्छिता?",
SPINSTR43:"यशस्वीरित्या सबमिट केले. रोख / डीडी / चेक देयकासाठी महाविद्यालय / विद्यापीठाकडे जा",
SPINSTR44:"आपले देय व्यवहार प्रक्रियेत आहे कृपया प्रतीक्षा करा ...",
SPINSTR45:"आपला देय व्यवहार यशस्वी आहे, आपला व्यवहार क्रमांक आहे",
SPINSTR46:"आपले देयक व्यवहार अयशस्वी झाले, आपला व्यवहार क्रमांक आहे",
SPINSTR47:"आपले देय व्यवहार प्रक्रियेत आहेत ...",
SPINSTR48:"कृपया फॉर्म बंद करा आणि पुन्हा तपासा ...",
SPINSTR49:"टीप: एकदा आपण विनंती सबमिट केल्यावर आपल्याला विनंती सुधारित करण्यास परवानगी नाही",
SPINSTR50:"टीपः एकदा आपण फी भरल्यानंतर आपल्याला विनंती रद्द करण्याची परवानगी नाही",
SPINSTR51:"टीप: एकदा आपण विनंती सबमिट केल्यावर आपल्याला विनंती सुधारित / रद्द करण्याची परवानगी नाही",
SPINSTR52:"आपण केवळ निवडू शकता",
SPINSTR53:"प्रति सेमेस्टर कोर्स",
SPINSTR54:"शिफारस केलेला ब्राउझरः Google Chrome 25 वरील नंतरच्या आवृत्त्या",
SPINSTR55:"समर्थन ईमेल आयडी: e_support@uaems.com",
SPINSTR56:"विद्यार्थी पोर्टल",
SPINSTR57:"विद्यापीठ प्रवेश व परीक्षा व्यवस्थापन प्रणाली (युएईएमएस) ऑनलाइन प्रवेश प्रक्रियेमध्ये आपले स्वागत आहे.",
SPINSTR58:"अर्ज करण्यासाठी, आपल्याला प्रथम नोंदणी प्रक्रिया पूर्ण करावी लागेल.",
SPINSTR59:"आपला वापरकर्ता आयडी आणि संकेतशब्द वापरुन आपण लॉग इन आणि विद्यार्थी प्रोफाइल पूर्ण करू शकता.",
SPINSTR60:"आपले वापरकर्ता आयडी आणि संकेतशब्द वापरुन आपण लॉग इन करुन अर्ज भरू शकता",
SPINSTR61:"चुकीची माहिती भरलेली आढळल्यास, कोणतीही नोंदणी नाकारण्यास विद्यापीठ जबाबदार आहे कायदेशीर कारवाई करू शकते.",
SPINSTR62:"अभ्यासक्रमाच्या तपशीलाशी संबंधित माहितीसाठी, प्रवेश परीक्षा वेळापत्रक विद्यापीठाच्या वेबसाइटला भेट द्या.",
SPINSTR63:"ऑनलाईन फॉर्म भरण्यासंदर्भात माहिती, अर्जाची स्थिती https://uaems.com वेबसाइटवर उपलब्ध असेल.",
SPINSTR64:"आपण दिलेल्या बॅचसाठी वेबसाइटवर अपलोड केलेले नियम आणि कायदे, उपक्रम, माहितीचे पालन करण्यास आपण सहमत असले पाहिजे.",
SPINSTR65:"या संदर्भातील सर्व वाद महाराष्ट्राच्या कायदेशीर कार्यक्षेत्रात आहेत.",
SPINSTR66:"सूचना",
SPINSTR67:"कृपया आपण नोंदणी दरम्यान वापरलेला आपला लॉगिन आयडी आणि संकेतशब्द प्रविष्ट करा",
SPINSTR68:"आपण कोणालाही आपला संकेतशब्द उघड करू नका किंवा सामायिक करू नका.",
SPINSTR69:"केवळ अधिकृत वापरकर्ते पुढे जाऊ शकतात.",
SPINSTR70:"आपला आयपी पत्ता आणि इतर माहिती सुरक्षिततेच्या कारणास्तव हस्तगत केली जाईल.",
SPINSTR71:"कोर्स तपशील आणि परीक्षेचे वेळापत्रक खाली विद्यापीठाच्या दुव्यास भेट द्या",
SPINSTR72:"ऑनलाईन प्रक्रिया पूर्ण करण्यात तुम्हाला अडचण / अडथळा निर्माण झाल्यास कोणत्याही वेळी टोल फ्री क्रमांकावर तुमच्या नोंदणीकृत मोबाइल क्रमांकावर संपर्क साधा.",
SPINSTR73:"धन्यवाद",
SPINSTR74:"युएईएमएस टीम.",
SPINSTR75:"टोल फ्री क्रमांक: 18002662998",
SPINSTR76:"वेळः सकाळी 9:30 ते 6.30 वाजता",
SPINSTR77:"स्क्रीन वाचक",
SPINSTR78:"अद्याप खाते नाही?",
SPINSTR79:"कृपया आपण पुढे जाण्यापूर्वी आपल्या हातात तयार असलेल्या अनुप्रयोगासाठी आवश्यक अशी माहिती असल्याची खात्री करा.",
SPINSTR80:"माझ्याकडे माझा स्वतःचा वैध ईमेल आयडी आणि मोबाईल नंबर आहे आणि मी एकमेव वापरकर्ता आहे.",
SPINSTR81:"माझ्याकडे माझ्या पासपोर्ट आकाराच्या रंगाच्या छायाचित्रांची कॉपी आहे (min.72 ते जास्तीत जास्त 150 डीपीआय सह स्कॅन केलेली).",
SPINSTR82:"माझ्याकडे जन्मतारखेचा पुरावा आहे (डीओबी) (आधार कार्ड, पॅनकार्ड, शाळा सोडणे, वाहन चालविणे परवाना)",
SPINSTR83:"ओटीपीसाठी मोबाइल फोनची भौतिक उपलब्धता.",
SPINSTR84:"माझ्याकडे मागासवर्गासाठी जातीचे प्रमाणपत्र / जातीचे वैधता प्रमाणपत्र / नॉन-क्रीमीय लेअर आहे.",
SPINSTR85:"माझ्याकडे पात्रता परीक्षेसाठी मार्कशीट / उत्तीर्ण प्रमाणपत्र आहे.",
SPINSTR86:"माझ्याकडे गॅझेट नोटिफिकेशन आहे (जर आपण अर्ज करू इच्छित असलेल्या नावापेक्षा कागदपत्रांची नावे वेगळी असतील तर)",
SPINSTR87:"ऑनलाईन नेट बँकिंग / डेबिट कार्ड / क्रेडिट कार्ड तपशील",
SPINSTR88:"मी वरील सर्व सबमिट करीत आहे ज्यात स्वेच्छेने इतर वैयक्तिकरित्या ओळखण्यायोग्य माहितीचा समावेश असू शकेल. मला पूर्ण माहिती आहे की महाविद्यालये, विद्यापीठ, सरकार, त्यांच्याशी संबंधित संस्था आणि त्यांचे कर्मचारी शैक्षणिक, प्रशासकीय, संशोधन, अंतर्गत गुणवत्ता ऑडिट आणि कायदेशीर हेतूंसाठी ही माहिती वापरतील आणि मी त्यांना त्यासाठी अधिकृत करीत आहे.",
SPINSTR89:"मी शैक्षणिक आणि प्रशासकीय माहिती देण्यासाठी वेळोवेळी माझ्या मोबाइल फोनवर मजकूर संदेश पाठविण्यास विद्यापीठास अधिकृत करतो.",
SPINSTR90:"मी प्रवेश विषयी प्रॉस्पेक्टस आणि नियम वाचले आहेत, अशा प्रकारे खाली 'कन्फर्म' बटणावर क्लिक करा.",
SPINSTR91:"माझ्याकडे वर नमूद केलेल्या कागदपत्रांच्या वैध ताब्यात आहे आणि मी शैक्षणिक कार्यक्रमाची संभावना वाचली आहे आणि मी स्वतःला समाधानी केले आहे की मी उपरोक्त कार्यक्रमासाठी पात्र आहे.",
SPINSTR92:"मी पोर्टलवर माझ्या स्वत: च्या ईमेल आयडी आणि मोबाइल नंबरसह स्वत: ची नोंदणी केली आहे.",
SPINSTR93:"मी स्वत: ची नोंदणी अचूक माहितीसह विद्यार्थी प्रोफाइलचे संबंधित विभाग अद्यतनित केले आहेत. प्रदान केलेली माहिती विद्यार्थी प्रोफाइल अंतिम आहे.",
SPINSTR94:"स्वत: ची नोंदणी दरम्यान माझा स्वतःचा वैध ईमेल आयडी आणि मोबाइल नंबर आहे.",
SPINSTR95:"मी उत्तीर्ण झालेल्या परीक्षेची गुण व गुण यादी आहे.",
SPINSTR96:"माझ्याकडे पात्रता परीक्षेची मार्कशीट आहे.",
SPINSTR97:"माझ्याकडे पात्रता परीक्षेचे उत्तीर्ण प्रमाणपत्र आहे.",
SPINSTR98:"मी कॉलेज / विद्यापीठात रोख / डीडी / चेक भरत आहे.",
SPINSTR99:"आपण केवळ सेट करू शकता",
SPINSTR100:"एकदा आपण सबमिट केल्यानंतर आपण त्यात सुधारणा करू शकत नाही",
SPINSTR101:"यशस्वीरित्या जोडले, आपणास शिष्यवृत्तीसाठी अर्ज करणे सुरू ठेवायचे आहे काय??",
ApplicationTitle:"अब्दुल कलाम कॉलेज",
IntegratedUniversityManagementSystem:"एकात्मिक विद्यापीठ व्यवस्थापन प्रणाली",
Typetheabovetext:"वरील मजकूर टाइप करा",
Donthaveanaccount:"खाते नाही?",
SelectLanguage:"भाषा निवडा",
AdmissionStatus:"प्रवेशाची स्थिती",
EligibilityStatus:"पात्रता स्थिती",
EligibilityDateRemark:"टिप्पणीसह पात्रतेची तारीख",
ApprovalDateRemark:"टिप्पणीसह मंजुरीची तारीख",
ApprovedStatus:"मंजूर स्थिती",
GeneralMerit: "सामान्य गुणवत्ता",
PhysicalHandicapMerit: "शारीरिक अपंगत्व योग्यता",
SocialReservationMerit: "सामाजिक आरक्षण गुणवत्ता",
CasteMerit: "जातीमधील गुणवत्ता",
FemaleMerit: "स्त्रीयांची गुणवत्ता",
SubmissionDate:"फॉर्म जमा करण्याची तारीख",
HallTicketGeneration:"परीक्षा प्रवेशपत्र निर्मिती",
HallTicketNo:"परीक्षा प्रवेशपत्र क्रमांक ",
EnteranceExamAttendance:"प्रवेश परीक्षेची उपस्थिती",
EntranceResult:"प्रवेशाचा निकाल",
AllotmentStatus: "वाटप स्थिती",
Logout: "बाहेर पडणे",
TollFreeNo:"टोल फ्री क्रमांक",
Preference:"प्राधान्य",
PrintHallTicket:"प्रिंट हॉल तिकीट",
UniversityAdmissionsExaminationManagement:"विद्यापीठ प्रवेश व परीक्षा व्यवस्थापन प्रणाली",
SyllabusGroupINS:"आपण निवडू शकता जास्तीत जास्त विषय",
ExamGroup:"परीक्षा गट",
ExamResult:"परीक्षेचा निकाल",
ViewResult:"निकाल पहा",
BuildingName:"इमारतीचे नाव",
RoomNo:"खोली क्रमांक",
BedNo:"बेड नं",
MessApplicable:"खानावळ लागू",
RoomTypeName:"खोली प्रकार",
HostelDetails:"वसतिगृह तपशील",
PrevPercentage:"मागील % ",
StudentLevel:"शैक्षणिक स्तर",
Facilities:"सुविधा",
HostelType:"वसतिगृहाचा प्रकार",
PlacementCompanyRequirementDetail:"प्लेसमेंट कंपनीची आवश्यकता तपशील",
CompanyName:"कंपनीचे नाव",
DesignationName:"हुद्दा",
JobLocation:"नोकरीचे स्थान",
NoOfPosts:"पोस्ट नाही",
CompanyAddress:"कंपनीचा पत्ता", 
WebURL:"वेब यूआरएल",
TelephoneNo:"दूरध्वनी क्रमांक.", 
RequiredSkillSet:"आवश्यक कौशल्य संच",
SalaryOffered:"पगार दिला",
NoOfYearsBond:"वर्षांची संख्या बाँड", 
FeesHead:"फी शीर्षक",
OnLinePaymentTransactionID:"व्यवहार क्रमांक",
PaymentDate:"देय तारीख",
NoOfInstallment:"हप्त्यांची संख्या",
PaymentDetails:"फी तपशील",
PendingFees:"प्रलंबित फी",
InstallmentFees:"हप्ता फी",
PayableAmount:"देय रक्कम",
ScholarshipName:"शिष्यवृत्तीचे नाव",
AppliedForAnyStateOrNationalScholarship:"इतर कोणत्याही राज्य किंवा राष्ट्रीय शिष्यवृत्तीसाठी अर्ज केला ?",
CurrentProgramDetails:"चालू कार्यक्रमतपशील",
LastYearExamDetails:"मागील वर्षाच्या परीक्षेचा तपशील",
FromDate:"तारखे पासून",
NotificationDate:"अधिसूचना तारीख",
ToDate:"तारीख पर्यंत",
ApplyFromDate:"तारखेपासून अर्ज करा",
ApplyTillDate:"तारीख पर्यंत अर्ज करा",
ScholarshipDetail:"शिष्यवृत्ती तपशील",
ScholarshipRegistrationDetail:"शिष्यवृत्ती नोंदणी तपशील",
ScholarshipAppliedDetail:"शिष्यवृत्ती लागू तपशील",
ScholarshipCategory:"शिष्यवृत्ती वर्ग",
ApplyForScholarship:"शिष्यवृत्तीसाठी अर्ज करा",
UrbanRuralTypeName:"शहरी ग्रामीण प्रकार",
FatherIsAlive:"वडील हयात आहे ?",
MotherIsAlive:"आई हयात आहे ?",
ApplicantIsEldestInTheFamily:"अर्जदार कुटुंबातील जेष्ठ आहे ?",
FamilyIsDependentOnApplicant:"अर्जदारावर कुटुंब अवलंबून आहे ?",
ApplicantIsStudyingInNightCollege:"अर्जदार रात्र महाविद्यालयमध्ये शिकत आहे ?",
SportName: "खेळाचे नाव",
SportDate: "खेळाच्या तारखा",
PlaceName: "ठिकाणाचे नाव",
PerformanceType: "कामगिरी प्रकार",
Level: "पातळी",
Rank: "स्थान",
Marks:"गुण",
TotalMarks:"गुण",
GradePoints:"",
ObtGradePoints:"Obt Gd.Pt",
FeedbackCategory:"अभिप्राय वर्ग",
QuestionDescription:"प्रश्न वर्णन",
ProspectusFees:"प्रॉस्पेक्ट फी",
ProgramType:"अभ्यासक्रम प्रकार",
Medium:"मध्यम",
ProspectInstruction:"कोर्स प्रॉस्पेक्ट खरेदी",
ViewInstruction:"सूचना पहा",
GoToProfile:"प्रोफाइल वर जा",
GoToLogIn:"लॉगइन वर जा",
IAgreeText:" मी सहमत आहे",
Applycourseforview:"आपल्या शैक्षणिक पात्रता पात्रता कार्यक्रमांनुसार पहा",
ProspectScheduleStartDate:"खरेदी प्रारंभ दि.",
ProspectScheduleEndDate:"खरेदी समाप्ती दि.",
Student:"विद्यार्थी",
CertificateTitle:"प्रमाणपत्र शीर्षक",
CertificateAuthority:"प्रमाणपत्र प्राधिकरण",
Subject:"विषय",
PurposeName:"हेतू नाव",
Narration:"कथन",
ReceiptNo:"पावती क्रमांक",
SchoolUdise:"शाळा यूडीआयएस",
SaralID:"सरल आयडी",
AadharNoID:"विद्यार्थी आधार क्र.",
ABCID:"ABC आयडी",
SupportContacts:"संपर्क क्रमांक",
AcedemicYear:"शैक्षणिक वर्ष",
ISExternalStudent:"प्रथम वर्षासाठी अर्ज करीत नाही",
BirthPlace:"जन्म स्थान", 
BirthThasil:"जन्म तहसील",
BirthDistrict:"जन्म जिल्हा",
BirthState:"जन्म राज्य",
BirthCountry:"जन्म देश",
LoginAS:"म्हणून लॉगिन करा",
InstructionForSelfRegistration:"स्वत: ची नोंदणीसाठी सूचना",
GrievanceSubmission:"तक्रार सबमिशन",
GrievanceType:"तक्रार प्रकार",
Date:"तारीख",
SelectFile:"फाईल सिलेक्ट करा",
ActionTaken:"कारवाई केली",
Feedback:"अभिप्राय",
Division:"वर्ग विभाग",
RecessTime:"विश्रांती वेळ",
WeeklyOff:"साप्ताहिक बंद",
SlotTime:"स्लॉट वेळ",
Monday:"सोमवार",
Tuesday:"मंगळवार",
Wednesday:"बुधवार",
Thursday:"गुरुवार",
Friday:"शुक्रवार",
Saturday:"शनिवार",
Sunday:"रविवारी",
Show:"दाखवा",
Day:"दिवस",
Teacher:"शिक्षक",
HolidayDescription:"सुट्टी / रविवार"
}]

@Injectable({
  providedIn: 'root'
})
export class LanguageenglishService {
  constructor() { }
  GetlanguageEnglishList(){
    return  EnglishList;
  }
  GetlanguageMarathiList(){
    return MarathiList;
  }
  getlanguageProducts(){
    return languageProducts;
  }
}